<div class="content" [fxLayout]="to.fxLayout" [fxLayoutAlign]="to.fxLayoutAlign" [fxLayoutGap]="to.fxLayoutGap"
    fxLayout.xs="column">
    @for (f of field.fieldGroup; track f) {
    <formly-field [field]="f" fxFlex=""></formly-field>
    }
</div>